// docs: https://github.com/altostra/type-validations#readme
import { enumOf, maybe, objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

const auditMetadataValidator = objectOf({
  name: string,
});

export const isEngagementLandingPagesDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      landing_page_id: string,
      name: string,
      description: string,
      marked_as_deleted: boolean,
      enabled: boolean,
      last_edited: maybe(number, true),
      last_edited_by: maybe(string, true),
      created_by: maybe(string, true),
      created: auditMetadataValidator,
      last_edit: auditMetadataValidator,
      status: string,
      impressions: number,
      form_submissions: number,
      size_limit_status: maybe(enumOf("ok", "blocked", "warned"), true),
      size_limit_status_updated_at: maybe(number, true),
    })
  ),
});
